<template>
  <div class="login">
    <h1 class="center-text">Enter Email To Reset Password</h1>
    <form @submit.prevent="login">
      <div class="form-300 center-element">
        <div v-if="apiError" class="error form-300">
          Error: {{ apiErrorMessage }}<br />
        </div>
        <label>Email</label><br />
        <input
          ref="emailField"
          v-model.trim="user.email"
          type="text"
          placeholder="Email"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Email'"
          required
        /><br />
        <button type="submit" class="button button-300">Reset Password</button>
      </div>
    </form>
  </div>
</template>

<script>
import api from "@/api/index";
const apiServiceUser = new api.APIServiceUser();

export default {
  data() {
    return {
      user: {
        email: ""
      },
      apiError: false,
      apiErrorMessage: ""
    };
  },
  created() {
    this.apiError = false;
    this.apiErrorMessage = "";
  },
  methods: {
    login: function() {
      this.apiError = false;
      this.apiErrorMessage = "";
      if (this.user.email) {
        apiServiceUser
          .resetPassword(this.user)
          .then(data => {
            this.$router.push("/console/resetpasswordinstructions");
          })
          .catch(error => {
            this.apiError = true;
            this.apiErrorMessage = error;
          });
      }
    }
  }
};
</script>
<style></style>
